import React from 'react';
import classnames from 'classnames';
import { captureException } from '@sentry/browser';
import { Icon } from '~/lib/bn-material-ui';
import { useStore } from '~/utility/BinSentry-ui-utility';
import { isOrderLate } from '~/orders/order-helpers';

export function OrderIcon({ orderEntity, className }) {
  const { isProducer } = useStore();
  if (!orderEntity) {
    return <Icon className={classnames('fas fa-spinner fa-pulse', className)} />;
  }

  const { state, type } = orderEntity.properties;
  const isLate = isOrderLate(orderEntity);

  switch (state) {
  case 'draft': {
    return <Icon className={classnames('far fa-calendar-edit', className)} />;
  }
  case 'scheduled': {
    if (isLate) {
      return <LateIcon className={className} />;
    }

    return <Icon className={classnames('far fa-calendar', className)} />;
  }
  case 'delivered': {
    if (isLate) {
      return <LateIcon className={className} />;
    }

    return <Icon className={classnames('fas fa-calendar-check', className)} />;
  }
  case 'not-delivered': {
    return <Icon className={classnames('fas fa-calendar-times', className)} />;
  }
  case 'ready': {
    if (type === 'suggestion') {
      return <Icon className={classnames('fas fa-sparkles', className)} />;
    }

    if (type === 'request') {
      if (isProducer) {
        return <Icon className={classnames('fas fa-hourglass-end', className)} />;
      } else {
        return <Icon className={classnames('fas fa-exclamation', className)} />;
      }
    }

    return <Icon className={classnames('far fa-hourglass-half', className)} />;
  }
  case 'dismissed': {
    return <ClosedOrDismissedIcon className={className} />;
  }
  case 'closed': {
    return <ClosedOrDismissedIcon className={className} />;
  }
  default: {
    captureException(`OrderIcon | Unknown order status: ${state}`);
    return <Icon className={classnames('fas fa-question', className)} />;
  }
  }
}

function ClosedOrDismissedIcon ({ className }) {
  return <Icon className={classnames('fas fa-ban', className)} />;
}

function LateIcon ({ className }) {
  return <Icon className={classnames('far fa-calendar-exclamation', className)} />;
}
